import {ListEntrySquished} from "../Common/Elements/ListEntry";
import {formatBalanceNumber} from "../../communication/format";
import {Friend} from "../../types/farming";

import './FriendEntry.css'
import {getImageUrl} from "../../communication/communication";

export const defaultPicture = <svg className="circle-image" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
    <rect width="64" height="64" rx="32" fill="#5E5E5E"/>
    <circle cx="32.0002" cy="25.3334" r="6.66667" fill="#212121"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M22.1358 44.4136C20.4865 43.6151 19.8124 41.6158 20.8107 40.0791C23.1879 36.42 27.3112 34 31.9998 34C36.6884 34 40.8118 36.42 43.1889 40.0791C44.1872 41.6158 43.5132 43.6151 41.8638 44.4136C38.8817 45.8572 35.5353 46.6667 31.9998 46.6667C28.4644 46.6667 25.118 45.8572 22.1358 44.4136Z"
          fill="#212121"/>
</svg>

export function FriendEntry({friend} : {friend : Friend}) {
    const friendBalanceString = friend.balance_diff > 0 ? `+${formatBalanceNumber(friend.balance_diff / 10)} Test Credits` : "0 Test Credits"
    const friendBalanceColor = friend.balance_diff > 0 ? "bonus-blue" : "bonus-gray"
    const imageSource = getImageUrl(friend.photo_url ?? "undefined");
    const picture = friend.photo_url === undefined ? defaultPicture : <img className="circle-image" src={imageSource} alt=""/>
    const displayName = friend.username ? friend.username : friend.first_name;

    const entry = <ListEntrySquished
        imageElement={<div className="flex-center">{picture}</div>}
        title={<span className="medium-font font-white fw-400 micro-margin-all"> {displayName} </span>}
        subscript={<span className={`micro-margin-all ${friendBalanceColor}`}> {friendBalanceString} </span>}
        rightText={<span className="friend-balance">{`${formatBalanceNumber(friend.balance)}`}</span>}
    />

    return <div className="small-margin list-entry-bg">
        {entry}
    </div>
}